<bp-content class="full-height" [class.in-iframe]="isIframeMode">
  @if (getWallet() && (hasAdvTradingReservedFunds$ | async); as showAdvTrading) {
    <div class="wallet-details-header">
      @if (!isIframeMode) {
        <div class="wallet-details-header__links container-left-right">
          <div>
            <a class="wallet-details-header__links__link" [routerLink]="['/portfolio']">
              <span class="bpi__icon-caret-left"></span>
              <span class="font-size-15 pl-15">
                {{ "portfolio_overview_button_text" | translate }}
              </span>
            </a>
          </div>
        </div>
      }
      <div class="wallet-details-header__masthead">
        <div class="wallet-details-header__masthead__title">
          <div class="wallet-details-header__masthead__title__symbol">
            <img
              [src]="getCurrency()?.getLogo()"
              (error)="img.src = getCurrency()?.getDefaultLogo()"
              alt="{{ 'logo_alt_text' | translate }}"
              #img />
          </div>
          {{ walletName | async }}
          @if (isLegacyDigiAsset) {
            <div class="legacy-label-wrapper">
              <legacy-label></legacy-label>
            </div>
          }
          @if (!isLeveragedToken) {
            <a
              (click)="openWalletDetails()"
              class="wallet-details-header__masthead__title__edit-icon">
              <span class="bpi__icon-edit wallet-details-header__masthead__title__edit-icon__actual"></span>
            </a>
          }
        </div>
        <div class="wallet-details-header__masthead__amount">
          <div class="wallet-details-header__masthead__amount__actual">
            {{ getSplitBalance()[0] }}
            <span class="wallet-details-header__masthead__amount__actual__small">
              {{ getSplitBalance()[1] + getSplitBalance()[2] }}
            </span>
            <span class="wallet-details-header__masthead__amount__actual__currency">
              {{
              getWallet().getBalance()
              | tradable_precision_symbol: { id: getWallet().getCurrencyId(), onlyUnit: true }
              }}
            </span>
          </div>
          <span class="wallet-details-header__masthead__amount__exchanged text-light">
            {{
            toFiat(getWallet()?.getBalance())
            | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat] }
            }}
          </span>
        </div>
      </div>
      @if (!isIframeMode) {
        @if (showAdvTrading.isAdvancedTradingEnabled && showAdvTrading.reservedFunds > 0) {
          <div
            class="wallet-balance-reserved-funds"
            >
            <div class="wallet-balance-reserved-funds-title">{{ "reserved_funds" | translate }}</div>
            <div class="wallet-balance-reserved-funds-amount">
              <div class="wallet-balance-reserved-funds-info-amount">
                {{
                showAdvTrading.reservedFunds
                | tradable_precision_symbol: { id: getWallet().getCurrencyId(), ignorePrecision: false }
                }}
              </div>
            </div>
          </div>
        }
        @if (isRealSecurity) {
          @let realSecuritiesRedirectionType = (realSecuritiesRedirectionType$ | async).value;
          @if (realSecuritiesRedirectionType === REDIRECTION_TYPE.PLAN_A) {
            <real-securities-banner
              [title]="'inline_banner_real_securities_trade_title' | translate: [getRSFeeText()]"
              [subtitle]="'inline_banner_real_securities_trade_subtitle' | translate"
              [linkTitle]="'discover_stocks_cta' | translate"
              [linkURL]="getV4RedirectURL()" />
          } @else if (realSecuritiesRedirectionType === REDIRECTION_TYPE.PLAN_B) {
            <real-securities-banner
              [title]="'inline_banner_real_securities_plan_b_title' | translate: [getRSFeeText()]"
              [subtitle]="'inline_banner_real_securities_coming_soon_web' | translate" />
          }
        }
        <!--ACTION BUTTONS-->
        <asset-mobile-action-button-wrapper
          [wallet]="getWallet()"
          [buttonActions]="getButtonActions()"
        [tradable]="getCurrency()"></asset-mobile-action-button-wrapper>
        <!---->
        @if (isLegacyDigiAsset) {
          <div class="sunset-banner-container">
            <sunset-digi-banner></sunset-digi-banner>
          </div>
        }
      }
      <div class="wallet-details-header__filters">
        <div class="bp-wrapper">
          <a
            class="filter-button btn btn-primary btn-sm"
            [ngClass]="{ 'is-active': noFilter() }"
            (click)="clearFilter()"
            (keydown.enter)="clearFilter()"
            [tabIndex]="0">
            {{ "show_all" | translate }}
          </a>
          <a
            class="filter-button btn btn-primary btn-sm"
						[ngClass]="{
							'is-active': isType('pending', 'public_status')
						}"
            (click)="filter('pending', 'public_status')"
            (keydown.enter)="filter('pending', 'status')"
            [tabIndex]="0">
            {{ "filter-button-pending" | translate }}
          </a>
          @for (buttonAction of getFilters(); track buttonAction) {
            <a
              class="filter-button btn btn-primary btn-sm"
              [ngClass]="{ 'is-active': isType(buttonAction) }"
              (click)="filter(buttonAction)"
              (keydown.enter)="filter(buttonAction)"
              [tabIndex]="0">
              {{ "filter-button-" + buttonAction | translate }}
            </a>
          }
        </div>
      </div>
    </div>
  }
  <!-- PENDING TRADES INFO-->
  @if (pendingTrades$ | async; as pendingTrades) {
    <transaction-pending-ribbon [pendingTrades]="pendingTrades">
    </transaction-pending-ribbon>
  }
  <div class="wallet-details__body center-block">
    @if ((paginationComponent.isLoading$() | async) === false) {
      <div>
        @for (keys of map?.keys(); track keys) {
          <div class="transactions-list">
            <div class="transactions-list-separator">
              <span>{{ keys }}</span>
            </div>
            @for (transaction of map?.get(keys); track transaction) {
              <tradable-transaction-list-item
                [transaction]="transaction"
                [focusable]="true"
                class="card-interactive">
              </tradable-transaction-list-item>
            }
          </div>
        }
        @if (map?.size === 0) {
          <empty [headline]="'wallet_detail_no_transactions_made' | translate"></empty>
        }
      </div>
    } @else {
      <empty [headline]="'loading' | translate"></empty>
    }
    <bp-pagination [ngClass]="'pagination-wrapper'"></bp-pagination>
  </div>
</bp-content>
